// extracted by mini-css-extract-plugin
export default {"title":"BadgeModal_title__e2fKn"};